export default import.meta.ROLLDOWN_FILE_URL_Uf4_Mq_h6hz3une2c30STA